import { render, staticRenderFns } from "./ItemsParser.vue?vue&type=template&id=9b107fa4&"
import script from "./ItemsParser.vue?vue&type=script&lang=ts&"
export * from "./ItemsParser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports